import { IForumTag } from 'Frontend/scripts/models/forums.model'
import { getForumTags } from 'Frontend/scripts/services/forums.service'
import { FunctionComponent, useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { createForumTag } from 'Frontend/scripts/services/dashboard.service'
import ManageTag from './ManageTag'
import DashboardItem from '../DashboardItem'
import { useTranslation } from 'react-i18next'

interface ITagName {
  tagName: string
}

interface ManageTagsProps {
  isAdmin: boolean
  isModerator: boolean
}

const ManageTags: FunctionComponent<ManageTagsProps> = ({ isAdmin, isModerator }) => {
  const { t } = useTranslation()
  const [tags, setTags] = useState<IForumTag[]>([])
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ITagName>({
    defaultValues: {
      tagName: '',
    },
  })

  const createTag = (data: ITagName) => {
    createForumTag(data.tagName).then(() => {
      reset()
      getAllForumTags()
    })
  }

  const getAllForumTags = () => {
    getForumTags().then((tagList: IForumTag[]) => {
      setTags(tagList)
    })
  }

  useEffect(() => {
    getAllForumTags()
  }, [])

  return (
    <DashboardItem heading={t('create-category-tag')}>
      {isAdmin && (
        <Form noValidate onSubmit={handleSubmit(createTag)}>
          <Form.Group>
            <Form.Label htmlFor="inputTag">{t('create-category-tag')}</Form.Label>
            <div className="input-group">
              <Form.Control
                id="inputTag"
                type="text"
                isInvalid={errors.tagName ? true : false}
                {...register('tagName', {
                  required: t('tags.tag-name-validation-message'),
                })}
              />
              <Button variant="secondary" type="submit">
                {t('create')}
              </Button>
              {errors.tagName && <p className="invalid-feedback mb-0">{errors.tagName.message}</p>}
            </div>
          </Form.Group>
        </Form>
      )}
      <div className="d-flex gap-2 flex-wrap mt-4">
        {tags.map((tag) => (
          <ManageTag
            key={`tag-${tag.id}`}
            tag={tag}
            callback={() => getAllForumTags()}
            isAdmin={isAdmin}
            isModerator={isModerator}
          />
        ))}
      </div>
    </DashboardItem>
  )
}

export default ManageTags
